module.exports = __webpack_public_path__ + "img/1-16.dee3dced.jpg";